import api from 'services/api';
import action from 'utils/action';
import checkError from 'utils/check-error';

export function projectSystemDefinitionCreateNote(note, projectId) {
  return (dispatch) => {
    dispatch(action('PROJECT_DEFINITION_CREATE_NOTE_REQUEST'));
    return new Promise((resolve, reject) => {
      if (!note) {
        // #if DEBUG
        console.warn('Project system definition - create error: invalid note (', note, ')');
        // #endif
        return reject({ error: 'Invalid note' });
      }

      const payload = {
        data: {
          attributes: note,
          relationships: {
            project: {
              data: { type: 'Project', id: projectId },
            },
          },
        },
      };
      return api.post('/api/project-notes', payload).then((response) => {
        if (checkError(response)) {
          // #if DEBUG
          console.warn('Project system definition - create error', response);
          // #endif
          dispatch(action('PROJECT_DEFINITION_CREATE_NOTE_FAILURE', response.json));
          reject(response.json);
        } else {
          dispatch(action('PROJECT_DEFINITION_CREATE_NOTE_SUCCESS', response.json));
          resolve(response.json);
        }
      }).catch((error) => {
        // #if DEBUG
        console.warn('Project system definition - create error', error);
        // #endif
        dispatch(action('PROJECT_DEFINITION_CREATE_NOTE_FAILURE', error));
        reject(error);
      });
    });
  };
}

export function projectSystemDefinitionPatchNote(note) {
  return (dispatch) => {
    dispatch(action('PROJECT_DEFINITION_PATCH_NOTE_REQUEST'));
    return new Promise((resolve, reject) => {
      if (!note) {
        // #if DEBUG
        console.warn('Project system definition - patch error: invalid note (', note, ')');
        // #endif
        return reject({ error: 'Invalid note' });
      }
      const { id } = note;

      const payload = {
        data: {
          attributes: note,
        },
      };
      return api.patch(`/api/project-notes/${id}`, payload).then((response) => {
        if (checkError(response)) {
          // #if DEBUG
          console.warn('Project system definition - patch error', response);
          // #endif
          dispatch(action('PROJECT_DEFINITION_PATCH_NOTE_FAILURE', response.json));
          reject(response.json);
        } else {
          dispatch(action('PROJECT_DEFINITION_PATCH_NOTE_SUCCESS', response.json));
          resolve(response.json);
        }
      }).catch((error) => {
        // #if DEBUG
        console.warn('Project system definition - patch error', error);
        // #endif
        dispatch(action('PROJECT_DEFINITION_PATCH_NOTE_FAILURE', error));
        reject(error);
      });
    });
  };
}

export function projectSystemDefinitionDeleteNote(note) {
  return (dispatch) => {
    dispatch(action('PROJECT_DEFINITION_DELETE_NOTE_REQUEST'));
    return new Promise((resolve, reject) => {
      if (note === null || typeof (note) === 'undefined') {
        // #if DEBUG
        console.warn('Project system definition - delete error: invalid note (', note, ')');
        // #endif
        return reject({ error: `Invalid note: ${note}` });
      }
      let noteId = note;

      if (typeof (note) === 'object') {
        noteId = note.id;
      }
      return api.delete(`/api/project-notes/${noteId}`).then((response) => {
        if (checkError(response)) {
          // #if DEBUG
          console.warn('Project system definition - delete error', response);
          // #endif
          dispatch(action('PROJECT_DEFINITION_DELETE_NOTE_FAILURE', response.json));
          reject(response.json);
        } else {
          dispatch(action('PROJECT_DEFINITION_DELETE_NOTE_SUCCESS', response.json));
          resolve(response.json);
        }
      }).catch((error) => {
        // #if DEBUG
        console.warn('Project system definition - delete error', error);
        // #endif
        dispatch(action('PROJECT_DEFINITION_DELETE_NOTE_FAILURE', error));
        reject(error);
      });
    });
  };
}



// WEBPACK FOOTER //
// ./js/actions/project-system-notes.js